import { useMutation } from '@apollo/client';

import { UpdateUserInput } from '../../apollo/__generated__/graphql';
import { UPDATE_USER } from '../graphql/mutation/updateUserMutation.graphql';
import { CURRENT_USER } from '../graphql/query/currentUserQuery.graphql';

export const useUpdateUserMutation = (onCompleted: () => void) => {
  const [mutate] = useMutation(UPDATE_USER, {
    refetchQueries: [{ query: CURRENT_USER }],
    onCompleted,
  });

  const updateUser = (updateUserInput: UpdateUserInput) => {
    mutate({
      variables: {
        updateUserInput,
      },
    });
  };

  return { updateUser };
};
